"use client";

import { openModal } from "action/modal/openModal";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import LoaderSkeleton from "component/loader-skeleton/LoaderSkeleton";
import { RootState } from "interfaces/generics.type";
import { MoveRight, SquarePen } from "lucide-react";
import FitmentIcon from "modules/fitment/fitment-icon/FitmentIcon";
import { useTranslation } from "next-i18next";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { getVehicleName } from "util/helper/getVehicleName";
import VehicleIcon from "../VehicleIcon";
import styles from "./homeGarage.module.scss";

const HomeGarage = () => {
  const { t } = useTranslation("common");
  const { loggedIn, firstName, refreshStatus } = useSelector((state: RootState) => state.authenticationState);
  const { selectedVehicle, isLoading } = useSelector((state: RootState) => state.garage);
  const dispatch = useDispatch();

  let vehicleDescription = t("Select Your Vehicle");
  let fitmentTitle = "";
  if (selectedVehicle) {
    vehicleDescription = getVehicleName(selectedVehicle, ["year", "make", "model"]);
    fitmentTitle = selectedVehicle.fitmentOptions.reduce((updatedTitle, option) => `${updatedTitle } ${ option.optionValue}`, "");
  }

  let vehicleComponent = (
    <>
      <VehicleIcon />
      <span
        className="p-l-10 vehicle-name text-uppercase"
        onClick={() => dispatch(openModal("vehicleSelector", {}))}
      >
        {vehicleDescription}
      </span>
    </>

  );
  if (selectedVehicle) {
    vehicleComponent = (
      <>
        <PAText component="p" bold className="text-center m-b-0">
          <PAText bold className="text-center">
            {vehicleDescription}
          </PAText>
          {" "}
          <SquarePen size={20} className={styles.edit_icon} onClick={() => dispatch(openModal("vehicleSelector", {}))} />
        </PAText>
        <div className="d-flex align-items-center justify-content-center">
          <HideIf show={fitmentTitle}>
            <FitmentIcon />

            <PAText
              component="p"
              color="medium-grey"
              className={`m-b-0 ${styles.selected_vehicle_description}`}
            >
              {fitmentTitle}
            </PAText>

          </HideIf>
        </div>
        {/* <i className="fa fa-pencil-square-o" onClick={() => dispatch(openModal("vehicleSelector", {}))} /> */}
      </>
    );
  }

  if (refreshStatus !== "complete" || isLoading) {
    return (
      <LoaderSkeleton count={3} height={30} />
    );
  }

  const welcomeText = loggedIn ? t("welcome_user", { name: firstName }) : (
    <div onClick={() => dispatch(openModal("login", {}))}>
      {t("Sign In For Saved Vehicles")}
      <MoveRight size={24} className={styles.signin_arrow} />
    </div>
  );

  return (
    <div className={`${styles.home_garage_container} ${!loggedIn ? styles.guest_login : ""}`}>

      <PAText
        fontSize={FONT_SIZE[2]}
        color="success-secondary"
        className={loggedIn ? styles.user_name : "d-flex align-items-center justify-content-center"}
      >
        {welcomeText}
      </PAText>

      <div className={selectedVehicle ? styles.selected_vehicle_container : styles.vehicle_container}>
        {vehicleComponent}
      </div>

    </div>
  );
};

export default HomeGarage;
